import getBirthdayCalendarCurrentState from '../selectors/getBirthdayCalendarCurrentState';
import getBirthdayCalendarInitialState from '../selectors/getBirthdayCalendarInitialState';

/**
 * Returns true if there is a change in the birthday calendar options
 */

export default function isBirthdayCalendarOptionDirty(): boolean {
    const currentState = getBirthdayCalendarCurrentState();
    const initialState = getBirthdayCalendarInitialState();

    if (initialState != null && currentState != null && initialState != currentState) {
        return true;
    }

    return false;
}
